// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PlayCircleOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48 83.5c19.606 0 35.5-15.894 35.5-35.5S67.606 12.5 48 12.5 12.5 28.394 12.5 48 28.394 83.5 48 83.5Zm0 4C26.185 87.5 8.5 69.815 8.5 48S26.185 8.5 48 8.5 87.5 26.185 87.5 48 69.815 87.5 48 87.5Zm18.43-34.157L41.377 67.25a5.992 5.992 0 0 1-5.879-.042 5.9 5.9 0 0 1-2.971-5.107V33.899a5.9 5.9 0 0 1 3-5.125 5.999 5.999 0 0 1 5.913.01L66.49 43.08a5.897 5.897 0 0 1 2.983 5.148 5.901 5.901 0 0 1-3.043 5.116Zm-1.921-6.79L39.458 32.26a1.998 1.998 0 0 0-1.96-.004 1.9 1.9 0 0 0-.971 1.644v28.202a1.9 1.9 0 0 0 .96 1.637 1.991 1.991 0 0 0 1.95.015l25.05-13.907c.606-.336.982-.967.986-1.642a1.897 1.897 0 0 0-.964-1.65Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default PlayCircleOutline;
